import CustomElement from '~utilities/custom-element';
import ToggleClass from '~utilities/toggle-class';
import TabIndexChildren from '~utilities/tab-index-children';

const JS_MODAL = 'js-modal';
const JS_MODAL_OPEN = 'js-modal-open';
const JS_MODAL_CLOSE = 'js-modal-close';
const ACTIVE_CLASS = 'is--active';
const JS_MODAL_BACKGROUND = 'js-modal-background';
const ESCAPE = 'Escape';

class Modal extends CustomElement {
    constructor() {
        super();
    }

    template() {
        return `
            <section class="c-modal ${this.className ? this.className : ''}" id="${this.id}" aria-modal="true" js-modal>
                ${this.innerHTML}
            </section>
        `;
    }

    callback() {
        super.callback();
        this.options();

        this.buttonsOpen = [...document.querySelectorAll(`[${JS_MODAL_OPEN}=${this.element.id}]`)];
        this.buttonsClose = [...this.element.querySelectorAll(`[${JS_MODAL_CLOSE}]`)];

        this.addModalBackground();
        this.modalBackground = document.querySelector(`[${JS_MODAL_BACKGROUND}]`);
        this.bindEvents();
    }

    bindEvents(){
        if(this.buttonsOpen) {
            this.buttonsOpen.forEach((open) => {
                open.addEventListener("click", () => this.openModal());
            });
        }
        if(this.buttonsClose) {
            this.buttonsClose.forEach((close) => {
                close.addEventListener("click", () => this.closeModal());
            });
        }
        this.modalBackground.addEventListener("click", () => this.closeModal());
        
        document.addEventListener('keyup', event => {
            if (event.code === ESCAPE) this.closeModal();
        });
    }

    options() {
        let attributes = this.getAttribute('js-options');
        if(!attributes) return;
        attributes = attributes.split('|');
        
        attributes.forEach(attribute => {
            switch(attribute) {
                case 'focusInput':
                    this.focusInput = true;
                    break;
                case 'url':
                    this.url = true;
                    this.triggerOnUrl();
                    break;
                default:
                    console.warn(`tab.options(): ${attribute} is not an option.`);
                    break;
            }
        });
    }
    
    

    triggerOnUrl() {
        this.urlParam = new URLSearchParams(window.location.search);
        const modalParam = this.urlParam.has(`modal`) ? this.urlParam.get(`modal`) : '';
        if(modalParam === this.element.id) this.openModal();
    }

    toggleModal(state){
        new ToggleClass(state, this.element, ACTIVE_CLASS);
        new ToggleClass(state, document.documentElement, 'has--modal');
    }

    openModal(){
        this.toggleModal(true);
        new TabIndexChildren('body', -1);
        new TabIndexChildren(this, 0, true);
        
        if(this.url) {
            this.urlParam.set('modal', this.element.id);
            window.history.replaceState(null, null, `${window.location.href.split('?')[0]}${this.urlParam.has('modal') ? `?modal=${this.urlParam.get('modal')}` : ''}`);
        }

        if(this.focusInput) {
            try{
                this.element.querySelector('input').focus();
            }catch(e){
            }
        }
    }

    closeModal(){
        this.toggleModal(false);
        new TabIndexChildren('body', 0);
        new TabIndexChildren(this, -1, true);
        
        if(this.url) {
            this.urlParam.delete(`modal`);
            window.history.replaceState(null, null, `${window.location.href.split('?')[0]}`);
        }

        const closeAttribute = this.buttonsClose[0].getAttribute(JS_MODAL_CLOSE);
        if(closeAttribute === 'remove') this.element.parentNode.removeChild(this.element);
    }

    addModalBackground() {
        const modalBackground = document.querySelector(`[${JS_MODAL_BACKGROUND}]`);
        if (!modalBackground) {
            const element = document.createElement(`div`);
            element.setAttribute(JS_MODAL_BACKGROUND, '');
            element.classList.add(`modal__background`);
            document.body.appendChild(element);
        }
    }
}

export default Modal;